const $doc = $(document);

// Contact form ajax submit

/*$('.form--contact .form__actions .btn').on('click', function(e) {
  e.preventDefault();

  const $this = $(this);
  const $form = $this.closest('form');
  const $sectionBody = $('.section-default--contact .section__body');
  let validated = true;

  $form.find('.field.required').each(function() {
    const $field = $(this);

    if ($field.val().length === 0) {
      validated = false;
      $field.addClass('error');
    } else {
      $field.removeClass('error');
    }
  });

  if (validated) {
    contactFormSubmit(
      $sectionBody,
      $form,
      Shopify.theme.locale.contact.success
    );
  }
});

function contactFormSubmit($sectionContent, $form, successMessage) {
  $.ajax({
    url: $form.attr('action'),
    type: 'post',
    dataType: 'json',
    data: $form.serialize()
  })
    .done(data => {
      $sectionContent.html(
        data.page.body_html +
          `<div class="form form--contact form--default"><div class="form__success">${successMessage}</div></div>`
      );
    })
    .fail(error => {
      $form.trigger('submit');
    });
}*/



// WEBPACK FOOTER //
// ../assets/js/ajax-forms.js